export { default } from './config'
